import React, { useState } from "react";
import CauHinhGiamTruTaiSan from "./ChucNang/CauHinhGiamTruTaiSan";
const DanhSachCauHinhTaiSanTableRows = ({
  list,
  pageIndex,
  pageSize,
  RoleSuaCauHinhTaiSan,
  RoleXoaCauHinhTaiSan,
  RoleKhoaCauHinhTaiSan,
  RoleMoCauHinhTaiSan,
  btnCapNhatTrangThaiClick,
  btnXoaCauHinhClick,
  btnSuaCauHinhTaiSanClick,
  btnCauHinhGiamTruTaiSanClick,
  RoleCauhinhGiamTru,
  isCauHinhT77,
}) => {
  return list.List.map((item, index) => {
    return (
      <div
        className="custom-table-row"
        key={"item" + index}
        style={{ minHeight: "62px" }}
      >
        <div className="custom-table-cell flex-basis-5 flex-basis-5-sm disk-mobile ">
          <span className="mobile-column-name color7-bold">STT</span>
          <div className="center-wrapper">
            <p className="text-center color7">
              {(pageIndex - 1) * pageSize + index + 1}
            </p>
          </div>
        </div>
        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm ">
          <span className="mobile-column-name color7-bold">Lĩnh vực</span>
          <div className="center-wrapper color7">
            {isCauHinhT77
              ? "Cầm đồ + huy động vốn + Trả góp"
              : "Cầm đồ + huy động vốn"}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm ">
          <span className="mobile-column-name color7-bold">Tên</span>
          <div className="center-wrapper color7" title={item.TenHangHoa}>
            {item.TenHangHoa}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-10 flex-basis-15-sm">
          <span className="mobile-column-name color7-bold">Mã</span>
          <div className="center-wrapper color7">{item.MaHangHoa}</div>
        </div>
        <div className="custom-table-cell flex-basis-35 flex-basis-30-sm">
          <span className="mobile-column-name color7-bold">Thuộc tính</span>
          <div
            className="center-wrapper color7"
            title={
              item.ThuocTinhTaiSan && item.ThuocTinhTaiSan.length > 0
                ? item.ThuocTinhTaiSan.map(
                    (tt, idx) => `${idx + 1}. ${tt.ValueThuocTinh}`,
                  ).join(", ")
                : ""
            }
          >
            {item.ThuocTinhTaiSan && item.ThuocTinhTaiSan.length > 0
              ? item.ThuocTinhTaiSan.map(
                  (tt, idx) => `${idx + 1}. ${tt.ValueThuocTinh}`,
                ).join(", ")
              : ""}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <span className="mobile-column-name color7-bold">Trạng thái</span>
          <div
            className="center-wrapper"
            style={
              item.TrangThaiHangHoa === 0
                ? {
                    padding: "6px",
                    borderRadius: "5px",
                    color: "#00B699",
                  }
                : {
                    padding: "6px",
                    borderRadius: "5px",
                    color: "#FF5C00",
                  }
            }
          >
            {item.TrangThaiHangHoa === 0 ? "Bình thường" : "Khóa"}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <div
            className="center-wrapper"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {RoleSuaCauHinhTaiSan && (
              <>
                <a title="Sửa" onClick={() => btnSuaCauHinhTaiSanClick(item)}>
                  <img src="/app-assets/images/icon-edit-v2.png" />
                </a>
              </>
            )}
            {RoleKhoaCauHinhTaiSan && item.TrangThaiHangHoa === 0 && (
              <>
                <a title="Khóa" onClick={() => btnCapNhatTrangThaiClick(item)}>
                  <img src="/app-assets/images/icon-mo-cau-hinh-tai-san.png" />
                </a>
              </>
            )}
            {RoleMoCauHinhTaiSan && item.TrangThaiHangHoa === 1 && (
              <>
                <a
                  title="Mở khóa"
                  onClick={() => btnCapNhatTrangThaiClick(item)}
                >
                  <img src="/app-assets/images/icon-khoa-cau-hinh-tai-san.png" />
                </a>
              </>
            )}
            {RoleCauhinhGiamTru && (
              <>
                <a
                  title="Cấu hình giảm trừ tài sản"
                  onClick={() => btnCauHinhGiamTruTaiSanClick(item)}
                >
                  <img src="/app-assets/images/icon-donglai.png" />
                </a>
              </>
            )}
            {RoleXoaCauHinhTaiSan && (
              <>
                <a
                  title="Xóa"
                  onClick={() => btnXoaCauHinhClick(item.CauHinhTaiSanId)}
                >
                  <img src="/app-assets/images/icon-xoa-v2.png" />
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    );
  });
};
const DanhSachCauHinhTaiSanTable = ({
  list,
  pageIndex,
  pageSize,
  RoleSuaCauHinhTaiSan,
  RoleXoaCauHinhTaiSan,
  RoleKhoaCauHinhTaiSan,
  RoleMoCauHinhTaiSan,
  btnCapNhatTrangThaiClick,
  btnXoaCauHinhClick,
  btnSuaCauHinhTaiSanClick,
  RoleCauhinhGiamTru,
  isCauHinhT77,
}) => {
  const [showModel, setshowModel] = useState(false);
  const [EditingItem, setEditingItem] = useState(null);
  const btnCauHinhGiamTruTaiSanClick = (item) => {
    setEditingItem(item);
    setshowModel(true);
  };
  if (!list || !list.List || list.List.length === 0) {
    return (
      <div className="custom-table-row">
        <div
          className="custom-table-cell-v2 text-center red"
          style={{ width: "100%" }}
        >
          Không có dữ liệu
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="Left808x200 Table-main-new css-table-ds">
        <div className="table-mobile sticky-table-bh2 table-mobile-hover">
          <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
            <div className="table-headers">
              <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                <p className="color-do-bold">
                  STT
                  <br />[{list.iTotal === 0 ? 0 : list.iTotal}]
                </p>
              </div>
              <div className="custom-table-header flex-basis-15 flex-basis-15-sm r">
                <p>Lĩnh vực</p>
              </div>
              <div className="custom-table-header flex-basis-15 flex-basis-15-sm ">
                <p>Tên</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-15-sm ">
                <p>Mã</p>
              </div>
              <div className="custom-table-header flex-basis-35 flex-basis-30-sm">
                <p>Thuộc tính</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                <p>Trạng thái</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-10-sm text-center">
                <p>Chức năng</p>
              </div>
            </div>
            <div className="custom-table-body">
              <DanhSachCauHinhTaiSanTableRows
                list={list}
                pageIndex={pageIndex}
                pageSize={pageSize}
                RoleSuaCauHinhTaiSan={RoleSuaCauHinhTaiSan}
                RoleXoaCauHinhTaiSan={RoleXoaCauHinhTaiSan}
                RoleKhoaCauHinhTaiSan={RoleKhoaCauHinhTaiSan}
                RoleMoCauHinhTaiSan={RoleMoCauHinhTaiSan}
                btnCapNhatTrangThaiClick={btnCapNhatTrangThaiClick}
                btnXoaCauHinhClick={btnXoaCauHinhClick}
                btnSuaCauHinhTaiSanClick={btnSuaCauHinhTaiSanClick}
                btnCauHinhGiamTruTaiSanClick={btnCauHinhGiamTruTaiSanClick}
                RoleCauhinhGiamTru={RoleCauhinhGiamTru}
                isCauHinhT77={isCauHinhT77}
              />
            </div>
          </div>
        </div>
      </div>
      {showModel && (
        <CauHinhGiamTruTaiSan
          data={EditingItem}
          onClose={() => setshowModel(false)}
        />
      )}
    </>
  );
};

export default DanhSachCauHinhTaiSanTable;
